// deviceDetails is a JSON object of the site's outputs/inputs keyed by pin number
export const parseDeviceDetails = (deviceDetails) => {
    if (!deviceDetails) return {};
    if (typeof deviceDetails === 'object') return deviceDetails;
    try {
        return JSON.parse(deviceDetails);
    } catch (e) {
        console.warn('Failed to parse deviceDetails', e);
        return {};
    }
}

// finds the output a CCTV integration is linked to (matched by pinName) and returns its current state
export const getLinkedOutputState = (rowData) => {
    const details = parseDeviceDetails(rowData.deviceDetails);
    const pin = Object.values(details).find(p => p?.pinName === rowData.pinName);
    if (!pin) return null;

    return {
        isOn: pin.pinState === 1,
        isActive: !!pin.active,
        label: pin.pinState === 1 ? pin.pinStatusOn : pin.pinStatusOff
    };
}
